<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Online Events</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div>
        <div class="title_fontStyle  h2"><i class="fas fa-caret-right"></i> Online Events</div>
        <h5 class="mt-5">Continuously brings in trends, technologies, and issues discussed by industry experts.</h5>
        <p>&zwnj;</p>

        <div class="row text-center text-lg-left">
          <div class="col-lg-4 mb-4">
            <a href="https://www.chanchao.com.tw/healthcos/en/eventSmile.asp" target="_blank">
              <img
                src="../../assets/images/Event_1.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log1()"
              />
              <p class="EventTitle py-1  ml-2">
                Best, safe and environmentally-friendly MIT cosmetics and formula in 2024.
              </p>
            </a>
          </div>

          <div class="col-lg-4 mb-4">
            <a href="https://www.chanchao.com.tw/healthcos/en/visitorFloorplan.asp" target="_blank">
              <img
                src="../../assets/images/Event_2.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log2()"
              />
              <p class="EventTitle py-1  ml-2">
                Quick preview for onsite expo scale in July.
              </p>
            </a>
          </div>

          <div class="col-lg-4 mb-4">
            <a href="https://www.chanchao.com.tw/healthcos/en/eventSeminar.asp" target="_blank">
              <img
                src="../../assets/images/Event_3.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
                @click="SaveEvent_log3()"
              />
              <p class="EventTitle py-1  ml-2">
                More than 30 exhibitors organize nearly 40 showcases and events, sharing industry knowledge and research
                results.
              </p>
            </a>
          </div>
        </div>
        <p>&zwnj;</p>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        token: '',
        CSRF_Token: '',
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },

    methods: {
      SaveEvent_log1() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent1 = `${NowPageUrl}#SmileUp`
        // console.log(OpenEvent1)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent1,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log2() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent2 = `${NowPageUrl}#FloorPlan`
        // console.log(OpenEvent2)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent2,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log3() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent3 = `${NowPageUrl}#Showcase`
        // console.log(OpenEvent3)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent3,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log4() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent4 = `${NowPageUrl}#Biotechnology`
        // console.log(OpenEvent4)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent4,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log5() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent5 = `${NowPageUrl}#Stocks`
        // console.log(OpenEvent5)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent5,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log6() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent6 = `${NowPageUrl}#Showcase`
        // console.log(OpenEvent6)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent6,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log7() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent7 = `${NowPageUrl}#YoutubeVideo`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent7,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      SaveEvent_log8() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent8 = `${NowPageUrl}#FloorPlan`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent8,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },
    },

    created() {
      const vm = this

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .EventBanner {
    transition: all 0.3s;
    background-size: cover;
    background-repeat: no-repeat;
    border: 1px solid gray;
    border-radius: 10px;
  }

  .EventTitle {
    font-size: 15px;
    line-height: 25px;
  }
</style>
